import { render, staticRenderFns } from "./IbButtonSecondary.vue?vue&type=template&id=16baea69&scoped=true"
import script from "./IbButtonSecondary.vue?vue&type=script&lang=js"
export * from "./IbButtonSecondary.vue?vue&type=script&lang=js"
import style0 from "./IbButtonSecondary.vue?vue&type=style&index=0&id=16baea69&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16baea69",
  null
  
)

export default component.exports